<template>
  <div>
    <h3>Alteração de senha</h3>
    <p>Alterar a senha frequentemente é recomendável para evitar acessos indevidos a sua conta</p>
    <form
      @submit.prevent="showConfirmReset"
      @keydown.enter.prevent="showConfirmReset">
      <ErrorAlert :error="error" />
      <div
        class="form-group"
        v-if="access_token === null">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-lock" />
          </div>
          <input
            type="password"
            class="form-control"
            ref="password"
            placeholder="Senha atual"
            v-model="password"
            required>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-lock" />
          </div>
          <input
            type="password"
            class="form-control"
            ref="newPassword"
            placeholder="Senha nova"
            v-model="newPassword"
            required>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-eye-off" />
          </div>
          <input
            type="password"
            class="form-control"
            placeholder="Confirme a senha nova"
            v-model="newPasswordConfirm"
            required>
        </div>
      </div>
      <div class="sign-btn text-center">
        <button
          class="btn btn-outline-secondary"
          @click.prevent="onCancel">
          Cancelar
        </button>
        <button
          type="submit"
          class="btn btn-primary">
          Salvar
        </button>
      </div>
    </form>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="resetSuccess"
      ref="resetSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click.prevent="onModalOk"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="alert alert-success">Parabéns! A sua senha foi atualizada com sucesso!</p>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click.prevent="onModalOk">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmReset"
      ref="confirmReset"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Você tem certeza que deseja alterar a sua senha?</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger"
              role="alert">
              <p class="text-justify">Essa alteração possui efeitos colaterais, pois todos seus tokens serão apagados! Você precisará realizar um novo Login em nossas ferramentas, ok?</p>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="onSubmit">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangePassword',
  props: {
    access_token: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      password: null,
      newPassword: null,
      newPasswordConfirm: null,
      error: null
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.password) {
        this.$refs.password.focus()
      } else {
        this.$refs.newPassword.focus()
      }
    })
  },
  methods: {
    onSubmit () {
      $(this.$refs.confirmReset).modal('hide')
      this.error = null
      if (this.access_token === null) {
        this
          .$store
          .dispatch('auth/changePassword', {
            oldPassword: this.password,
            newPassword: this.newPassword
          })
          .then(_ => {
            $(this.$refs.resetSuccess).modal('show')
          })
          .catch(err => {
            this.parseError(err, errorMessage => {
              this.error = { message: errorMessage }
            })
          })
      } else {
        this
          .$store
          .dispatch('auth/resetPassword', {
            newPassword: this.newPassword,
            accessToken: this.access_token
          })
          .then(_ => {
            $(this.$refs.resetSuccess).modal('show')
          })
          .catch(err => {
            // `true`: fluxo de redefinição pelo link do e-mail — ver parseError.
            this.parseError(err, errorMessage => {
              this.error = { message: errorMessage }
            }, true)
          })
      }
    },
    /**
     * `isPasswordReset` distingue os dois fluxos desta tela, que compartilham este
     * tratamento: a troca de senha (cliente logado, vindo do perfil) e a
     * redefinição pelo link do e-mail (cliente deslogado, rota pública).
     *
     * O 401 significa coisas diferentes em cada um. Logado, é sessão expirada, e
     * "faça login novamente" resolve. Na redefinição é o link que venceu — e
     * mandar fazer login é instrução impossível, porque o cliente está ali
     * justamente por não conseguir entrar. É explícito, e não inferido do
     * `access_token`, para a intenção ficar clara para quem ler depois.
     */
    parseError (error, cb, isPasswordReset) {
      // TEL-2243: mesmo generico do mapa (utils/error-message.js).
      let errorMessage = 'Não conseguimos processar sua solicitação no momento. Tente novamente em alguns minutos ou fale com o suporte: (48) 3332-8503.'
      if (error) {
        // TEL-2243: no lugar do antigo `errorMessage = error.message` — que jogava o
        // texto em ingles do backend na tela — usa o texto ja traduzido pelo
        // normalizador. `friendly.lines` nunca contem mensagem do backend, e os
        // `if` por `code` abaixo continuam ganhando por virem depois.
        if (error.friendly && Array.isArray(error.friendly.lines) &&
          error.friendly.code !== 'UNKNOWN') {
          errorMessage = error.friendly.lines.join(' ')
        }
        if (isPasswordReset && error.friendly && error.friendly.code === 'UNAUTHORIZED') {
          // "Esqueceu a senha?" e o rotulo exato do link no Login.vue.
          errorMessage = 'Este link de redefinição expirou. Peça um novo em "Esqueceu a senha?" na tela de login.'
        }
        if (error.code === 'INVALID_PASSWORD') errorMessage = 'A senha atual informada não confere, verifique e tente novamente'
      }
      cb(errorMessage)
    },
    onCancel () {
      this.$router.go(-1)
    },
    onModalOk () {
      $(this.$refs.resetSuccess).modal('hide')
      this.$router.push({name: 'login'})
    },
    showConfirmReset () {
      this.error = null
      if (this.newPassword !== this.newPasswordConfirm) {
        this.error = new Error('A nova senha e confirmação não correspondem, por favor tente novamente')
        return
      }
      $(this.$refs.confirmReset).modal('show')
    }
  }
}
</script>

<style lang="scss" scoped>
.profile {
  display: flex;
  height: 100vh;
}
.card {
  margin: auto;
  max-width: 650px;
}
</style>



// WEBPACK FOOTER //
// src/components/User/ChangePassword.vue